module.exports = new __parcel__URL__("light.d1fb3de6.svg").toString();